import styled, { keyframes } from 'styled-components'

const shimmer = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
`

export const Container = styled.div`
  display: flex;
  flex-flow: column wrap;
  min-height: 100%;
  justify-content: start;
  background-color: var(--color-background-neutral-default);
  padding-bottom: 48px;
  padding-top: 54px;
`

export const ShimmerContainer = styled.div`
  width: 100%;
  padding: 0 24px;
  display: flex;
  flex-flow: column wrap;
  align-items: center;
`

export const SkeletonBox = styled.div<{ height: string }>`
  width: 100%;
  height: ${({ height }) => height};
  background-color: var(--color-surface-neutral-soft);
  border-radius: 14px;
  animation: ${shimmer} 1.5s ease-in-out infinite;
`
